var map = {
	"./background-products.jpg": "179b",
	"./icon-arrow-left-featured.svg": "d64a",
	"./icon-arrow-left.svg": "9ef1",
	"./icon-arrow-right-black.svg": "7f52",
	"./icon-arrow-right-featured.svg": "064f",
	"./icon-arrow-right-gray.svg": "d300",
	"./icon-arrow-right.svg": "c43b",
	"./icon-caret-down.svg": "b0cd",
	"./icon-close.svg": "9e40",
	"./icon-coupon.svg": "51e9",
	"./icon-danger.svg": "a15b",
	"./icon-discount.svg": "e79c",
	"./icon-dollar.svg": "6dd3",
	"./icon-facebook.svg": "431d",
	"./icon-info-lilac.svg": "e6d8",
	"./icon-info.svg": "d399",
	"./icon-instagram.svg": "8158",
	"./icon-item-default.svg": "67c3",
	"./icon-mail.svg": "9409",
	"./icon-map-pin.svg": "8499",
	"./icon-menu.svg": "2d23",
	"./icon-minus.svg": "f41e",
	"./icon-payment-generic.svg": "25ef",
	"./icon-phone.svg": "6ab6",
	"./icon-plus.svg": "d0d5",
	"./icon-product-not-found.svg": "ff53",
	"./icon-search.svg": "66d7",
	"./icon-settings.svg": "426d",
	"./icon-shop-brand.svg": "6f55",
	"./icon-shopping-car.svg": "4a0b",
	"./icon-social-x.svg": "e2a2",
	"./icon-success.svg": "030e",
	"./icon-transfer.svg": "d54f",
	"./icon-trash.svg": "3294",
	"./icon-truck.svg": "6a55",
	"./icon-twitter.svg": "5cfb",
	"./icon-user.svg": "eac8",
	"./icon-warning-triangle.svg": "c40b",
	"./icon-warning.svg": "d112",
	"./item-default.png": "4308",
	"./logo-alegra-footer.svg": "0560",
	"./logo-company-test.svg": "863b",
	"./logo-full-greenpay.png": "f2b1",
	"./logo-full-mercado_pago.png": "1fc7",
	"./logo-full-nequi.png": "5999",
	"./logo-full-payu.png": "ab0c",
	"./logo-full-visanet.png": "db45",
	"./logo-full-wompi.png": "8307",
	"./logo-greenpay.png": "0d43",
	"./logo-mercado_pago.png": "f1be",
	"./logo-nequi.png": "a1cd",
	"./logo-paypal.png": "d631",
	"./logo-payu.png": "aa00",
	"./logo-visanet.png": "6fe7",
	"./logo-whatsapp.png": "9fa6",
	"./logo-wompi.png": "6687",
	"./phone-whatsapp.png": "b6c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";